import { render, staticRenderFns } from "./QualityCard.vue?vue&type=template&id=f9067310&"
import script from "./QualityCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./QualityCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports